
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11449',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11449",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.444",
  "data-fetching-client": "static-1.9441",
  "graphql": "static-1.76",
  "head-dlb": "static-1.4754",
  "hs-test-utils": "static-1.7770",
  "hub-http-shared-msw-handlers": "static-1.9391",
  "hubspot-dlb": "static-2.1796",
  "hubspot-url-utils": "static-1.3917",
  "HubStyleTokens": "static-2.11187",
  "I18n": "static-7.1559",
  "jasmine-runner": "static-1.6238",
  "marketplace-storefront-base": "static-1.11509",
  "quartz": "static-1.6680",
  "react-dlb": "static-1.71",
  "customer-data-property-utils": "static-1.7836",
  "foundations-components": "static-1.7452",
  "foundations-theming": "static-1.4173",
  "history": "static-4.47",
  "hub-http": "static-1.5966",
  "integrations-lib": "static-1.15299",
  "marketplace-ui-common": "static-1.18853",
  "PortalIdParser": "static-2.349",
  "property-management-iframe": "static-1.12172",
  "quartz-config": "static-1.458",
  "quartz-core": "static-1.5899",
  "quartz-routing": "static-1.110",
  "quick-fetch": "static-1.3701",
  "react": "static-7.177",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16405",
  "react-router-dom": "static-5.26",
  "rpc-client-utils": "static-1.4396",
  "SharedI18nStrings": "static-1.180",
  "trellis-ecosystem": "static-1.6658",
  "ts-schema": "static-1.3872",
  "ui-addon-i18n": "static-1.10895",
  "ui-addon-react-router-dom": "static-1.9312",
  "ui-universal-auth": "static-1.8642",
  "UIComponents": "static-3.8134",
  "usage-tracker": "static-1.7098",
  "usage-tracker-core": "static-1.6948",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.387",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven": "static-3.5624",
  "raven-hubspot": "static-1.5931",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9391",
  "react-redux": "static-7.66",
  "redux": "static-4.16",
  "styled-components": "static-2.84",
  "bend-plugin-trellis-migration": "static-1.3195",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2957",
  "quartz-webpack": "static-1.2904",
  "fast-json-stable-stringify": "static-1.4",
  "HeadJS": "static-2.701",
  "framer-motion": "static-1.66",
  "hs-test-utils-bend-plugin": "static-1.2881",
  "msw": "static-1.39",
  "testing-library": "static-1.146",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.77",
  "react-utils": "static-2.5142",
  "StyleGuideUI": "static-3.483",
  "jasmine": "static-4.4095",
  "ai-components-ui-library": "static-1.8252",
  "ai-rendering-library": "static-1.9193",
  "amplitude-session-replay-browser": "static-1.54",
  "chirp-fetch": "static-1.1647",
  "connections-embed-lib": "static-1.571",
  "copilot-toolkit": "static-1.10432",
  "foundations-assets": "static-1.4596",
  "hs-lodash": "static-4.45",
  "laboratory-lib": "static-3.6927",
  "marketplace-embed": "static-1.21384",
  "marketplace-ui-apps-core": "static-1.17386",
  "marketplace-ui-assets-core": "static-1.18790",
  "marketplace-ui-client-types": "static-1.16260",
  "marketplace-ui-details": "static-1.8749",
  "marketplace-ui-reviews": "static-1.18809",
  "marketplace-ui-tracking": "static-1.13024",
  "sanitize-text": "static-1.7904",
  "ui-addon-video-player": "static-1.8460",
  "usage-tracker-multi": "static-1.5512",
  "usage-tracker-session-replay": "static-1.4784",
  "wootric-nps": "static-1.6745",
  "customer-data-objects": "static-1.7408",
  "property-translator": "static-1.5178",
  "bend-plugin-foundations-components": "static-1.3721",
  "floating-ui": "static-1.50",
  "foundations-theming-specialty": "static-1.1889",
  "hs-story-utils": "static-1.9192",
  "react-aria": "static-1.60",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.93",
  "tanstack-table": "static-1.49",
  "trellis-assets": "static-1.1094",
  "ui-fonts": "static-1.449",
  "ui-images": "static-2.1083",
  "bend-plugin-foundations-theming": "static-1.2656",
  "foundations-theming-base": "static-1.3158",
  "stylex": "static-1.26",
  "flux-actions": "static-1.302",
  "frontend-preferences-client": "static-1.7691",
  "hs-promise-utils": "static-1.5355",
  "hubspot-apollo-client": "static-1.4643",
  "integrations-error-boundary-lib": "static-1.12714",
  "integrations-tracking-lib": "static-1.5348",
  "native-integrations-shared-strings": "static-1.7553",
  "quartz-i18n": "static-1.355",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10137",
  "reselect": "static-2.16",
  "rxjs": "static-5.10",
  "sanitize": "static-1.4239",
  "superstore": "static-1.4536",
  "ui-shepherd-react": "static-3.9909",
  "ai-settings-ui-library": "static-1.7331",
  "hub-http-janus": "static-1.784",
  "hubspotter-http": "static-1.4446",
  "immer": "static-1.33",
  "immutable-less": "static-1.4418",
  "nav-meta": "static-1.28788",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10000",
  "ui-addon-upgrades": "static-9.17597",
  "inbound-db-properties-service-client": "static-1.3644",
  "property-management-common": "static-1.4459",
  "ui-addon-iframeable": "static-1.8805",
  "dispatcher": "static-1.130",
  "general-store": "static-6.20",
  "icons": "static-2.618",
  "mobile-manifest-mixins": "static-1.474",
  "quartz-auth": "static-1.355",
  "quartz-head": "static-1.345",
  "quartz-test": "static-1.355",
  "usage-tracker-container": "static-1.7088",
  "csstype": "static-1.50",
  "storybook-react": "static-1.27",
  "trellis-story-utils": "static-1.4287",
  "foundations-components-test-utils": "static-1.4935",
  "react-input-autosize": "static-2.17",
  "cssUtils": "static-1.721",
  "HubStyle": "static-2.11495",
  "bender-build-tools": "static-1.2899",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20167",
  "ContentUtils": "static-1.67517",
  "sassPrefix": "static-1.151",
  "avatar-components": "static-1.2250",
  "customer-data-filters-ui": "static-1.38754",
  "customer-data-objects-ui-components": "static-1.12767",
  "customer-data-reference-ui-components": "static-1.12906",
  "embedded-academy-lib": "static-1.13380",
  "ExportDialog": "static-6.10152",
  "highlight.js": "static-1.73",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40545",
  "reporting-data": "static-1.66362",
  "reporting-snowflake": "static-1.54980",
  "reporting-ui-components": "static-2.63634",
  "reporting-visualizations": "static-1.58438",
  "ui-addon-teams": "static-1.21192",
  "magpie-lib": "static-1.5358",
  "magpie-types": "static-1.4818",
  "simple-logging-lib": "static-1.2815",
  "navigation-components": "static-1.17151",
  "navigation-messaging": "static-1.6478",
  "developer-experience-shared-components": "static-1.10230",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7749",
  "ui-extensibility-client-types": "static-1.3713",
  "signup-constants": "static-1.18318",
  "signup-ui-url-generator": "static-2.7827",
  "ai-studio-lib": "static-1.10894",
  "ui-tool-access": "static-1.9908",
  "usage-based-billing-components-lib": "static-1.7918",
  "usage-tracker-anonymous": "static-1.5515",
  "usage-tracker-public": "static-1.6909",
  "apollo-link-hub-http": "static-2.4413",
  "hubspot-apollo-cache": "static-1.102",
  "universal-page-editor-lib": "static-1.2763",
  "redux-toolkit": "static-1.7",
  "merchandise-lib": "static-1.257",
  "atom": "static-1.4835",
  "purchase-motions-components": "static-1.5433",
  "salesImages": "static-1.520",
  "upgrade-management-service-types": "static-1.4272",
  "batch-promise": "static-1.1314",
  "crm-component-utils": "static-1.38394",
  "crm-properties-common-lib": "static-1.5636",
  "framework-data-schema-resolvers": "static-1.6634",
  "inbound-db-meta-service-client": "static-1.3397",
  "reference-resolvers-lite": "static-1.7854",
  "hubspotter-http-shared-msw-handlers": "static-1.9389",
  "cms-field-types": "static-1.4571",
  "content-icons-ui": "static-1.2142",
  "underscore": "static-1.8",
  "conversations-skeleton-state": "static-1.7014",
  "crm-message-bus": "static-1.42242",
  "customer-data-filters-ui-msw-helpers": "static-1.21188",
  "customer-data-ui-utilities": "static-1.9589",
  "FormUrlGenerator": "static-2.4495",
  "framework-builder-read-service-client": "static-1.3815",
  "framework-data-schema-quick-fetch": "static-1.6539",
  "multi-account-reference-resolvers": "static-1.733",
  "onboarding-tours": "static-1.16209",
  "PatternValidationJS": "static-1.437",
  "react-immutable-proptypes": "static-2.8",
  "reference-resolvers": "static-1.7924",
  "reporting-datasets-permissions-lib": "static-1.12951",
  "academy-common-lib": "static-1.12840",
  "content-assistance-lib": "static-1.7396",
  "dashboard-lib": "static-1.80463",
  "file-manager-components": "static-1.22779",
  "getting-started-shared-tasks": "static-1.17780",
  "hubspot-prosemirror": "static-1.17502",
  "hubspot-prosemirror-plugins": "static-1.17494",
  "prosemirror": "static-1.13",
  "react-colorpicker": "static-2.9976",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "rich-text-lib": "static-1.19414",
  "share-with-third-party-component-lib": "static-1.8454",
  "ui-addon-draggable": "static-3.4530",
  "ui-asset-management-lib": "static-1.10662",
  "ui-business-units-lib": "static-1.8787",
  "user-context": "static-1.4859",
  "persist-promise": "static-1.3471",
  "reporting-client-types": "static-1.2372",
  "growth-payments-core": "static-1.24623",
  "highcharts": "static-8.98",
  "reporting-plugins": "static-1.9936",
  "reporting-reports": "static-1.66040",
  "idb-keyval": "static-1.38",
  "reactive-lib": "static-1.490",
  "apps-service-types": "static-1.3643",
  "oauth-service-types": "static-1.4004",
  "codemirror": "static-5.89",
  "feedback-loader": "static-1.28787",
  "react-codemirror": "static-1.10392",
  "onboarding-scopes": "static-1.6229",
  "onboarding-tours-client": "static-1.4423",
  "platform-infra-nav-components": "static-1.7460",
  "subscription-experience-data-types": "static-1.14539",
  "crm-record-cards-service-types": "static-1.3419",
  "location-customization-utils-lib": "static-1.8444",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4288",
  "nav-client-types": "static-1.2120",
  "purchase-motions-api": "static-1.5436",
  "trials-service-types": "static-1.3689",
  "card-properties-lib": "static-1.43421",
  "crm-actions": "static-1.6059",
  "crm-cards-data": "static-1.1138",
  "crm-cards-sdk": "static-1.42805",
  "customer-data-properties": "static-1.50682",
  "customer-data-properties-shared-msw-handlers": "static-1.8718",
  "customer-data-tracking": "static-1.6646",
  "conditional-properties-service-client": "static-1.3591",
  "crm-pipelines-api-client-types": "static-1.3932",
  "multi-currency-client-types": "static-1.3486",
  "external-options-client-types": "static-1.3951",
  "react-dnd-compat": "static-1.4388",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5118",
  "growth-onboarding-confetti": "static-1.2835",
  "growth-onboarding-next-action-utils": "static-1.1259",
  "onboarding-tours-utils": "static-1.275",
  "ui-shepherd-tracker": "static-1.7290",
  "academy-service-client": "static-1.3446",
  "final-form": "static-1.64",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.27849",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8151",
  "immerable": "static-1.3919",
  "video-components-external": "static-1.10468",
  "video-data-lib": "static-1.34126",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8333",
  "payment-link-components": "static-1.22835",
  "ui-addon-emoji-picker": "static-1.9654",
  "EmailSignatureEditor": "static-1.23859",
  "viral-links-lib": "static-1.6792",
  "data-token-picker": "static-1.15987",
  "FileManagerLib": "static-1.38419",
  "react-flip-move": "static-1.64",
  "timezone-utils": "static-2.5009",
  "getting-started-shared-tasks-store": "static-1.16898",
  "campaign-roi-lib": "static-1.8182",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "edison-service-client-types": "static-1.154",
  "eligibility-engine-service-types": "static-1.2970",
  "crm_data": "static-4.91099",
  "crm-links": "static-1.6018",
  "customer-data-sidebar": "static-2.45317",
  "enrichment-properties-lib": "static-1.14868",
  "crm-fe-perf": "static-1.22671",
  "calling-global-api": "static-1.63529",
  "calling-internal-common": "static-1.31056",
  "calling-lifecycle-internal": "static-1.64911",
  "calling-lifecycle-messages": "static-1.57205",
  "commerce-products-lib": "static-1.8746",
  "google-libphonenumber": "static-1.32",
  "hs-entities": "static-1.435",
  "inbounddb-objects-service-types": "static-1.4018",
  "meetings-icalendar-utils-lib": "static-1.398",
  "object-builder-ui-client": "static-1.47849",
  "pipeline-validation-client-types": "static-1.3755",
  "property-value-citations": "static-1.1296",
  "pulse": "static-1.266",
  "smart-property-lib": "static-1.5750",
  "tiered-pricing": "static-1.777",
  "ui-addon-form-validation": "static-1.10759",
  "growth-onboarding-feedback-components": "static-1.6350",
  "content-media-composition-data-lib": "static-1.11323",
  "content-media-compositions": "static-2.15330",
  "media-bridge-lib": "static-1.18509",
  "commerce-tours-lib": "static-1.5663",
  "growth-onboarding-reliability": "static-1.4853",
  "sales-checkout-service-client": "static-1.3441",
  "draft-convert": "static-2.31",
  "draft-extend": "static-3.69",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.21251",
  "sales-email-signature-service-client": "static-1.3608",
  "audio-components": "static-1.5561",
  "FileManagerCore": "static-1.38278",
  "FileManagerImages": "static-1.35930",
  "video-components": "static-1.12471",
  "crm_universal": "static-1.21604",
  "customer-data-email": "static-1.17611",
  "calling-error-reporting": "static-1.31062",
  "card-payment-highlight-lib": "static-1.36403",
  "card-subscription-highlight-lib": "static-1.38758",
  "commerce-billing-lib": "static-1.18396",
  "commerce-contract-lib": "static-1.11028",
  "customer-data-content": "static-1.26814",
  "invoices-highlight-card-lib": "static-1.53888",
  "orders-highlight-card-lib": "static-1.20785",
  "products-highlight-card-lib": "static-1.17030",
  "project-storage": "static-1.4497",
  "quotes-highlight-card-lib": "static-1.71023",
  "breeze-intelligence-kit": "static-1.5269",
  "crm-source-interpretation-lib": "static-1.5096",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9474",
  "fsm": "static-1.3496",
  "policy-lib": "static-1.6549",
  "shared-worker-versioning": "static-1.10802",
  "calling-usage-tracker": "static-1.6303",
  "voice-sms-access-library": "static-1.136",
  "products-iframe-lib": "static-1.7219",
  "products-ui-components-shared-msw-handlers": "static-1.9773",
  "directed-graph": "static-1.701",
  "event-emitter": "static-1.712",
  "react-tinymce": "static-1.54524",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9537",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53650",
  "tinymce-plugins": "static-1.56764",
  "tinymce-themes": "static-1.55620",
  "hls.js": "static-1.33",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4298",
  "video-embed": "static-1.34960",
  "social-insights-client-types": "static-1.21254",
  "sequences-lib": "static-1.7634",
  "ui-gdpr-components": "static-1.10111",
  "commerce-shared-components-lib": "static-1.17826",
  "commerce-subscription-lib": "static-1.36335",
  "commerce-tools-ui-lib": "static-1.9705",
  "utility-belt": "static-1.2306",
  "payments-enrollment-embed-lib": "static-1.21850",
  "products-ui-components": "static-1.39265",
  "quotes-client-types": "static-1.37111",
  "quotes-ui-lib": "static-1.79742",
  "SalesContentIndexUI": "static-3.8849",
  "accounting-integrations-ui-components": "static-1.6671",
  "invoices-ui-lib": "static-1.53904",
  "commerce-products-api": "static-1.1905",
  "SafeStorage": "static-1.4169",
  "invoices-iframe-lib": "static-1.55962",
  "quotes-modal-lib": "static-1.101699",
  "calling-orchestration-schema": "static-1.34913",
  "sales-views-client-types": "static-1.4056",
  "hub-http-contrib": "static-1.2809",
  "interframe": "static-3.4556",
  "tinymce-data": "static-1.39735",
  "ui-addon-sales-email": "static-1.4978",
  "layout-dnd-components": "static-1.11970",
  "layout-dnd-utils": "static-1.10945",
  "ui-brand-identity-lib": "static-1.13691",
  "NamespacedHubStyle": "static-2.8864",
  "outpost": "static-1.3972",
  "sequences-client-types-lib": "static-1.7491",
  "customer-data-associations": "static-1.7101",
  "framework-data-table": "static-2.11334",
  "customer-data-rte": "static-1.32361",
  "cv-backend-services": "static-1.1484",
  "growth-onboarding-empty-states": "static-1.5311",
  "InboxConnectUtils": "static-4.14131",
  "payments-post-enroll-local-storage-lib": "static-1.4877",
  "qrcode-generator": "static-1.63",
  "stripe-embedded-components": "static-1.7076",
  "commerce-permissions": "static-1.517",
  "commerce-tax-lib": "static-1.270",
  "property-description-translator": "static-1.3624",
  "FireAlarmUi": "static-1.4295",
  "sales-templates-service-types-lib": "static-1.3961",
  "commerce-analytics-service-client": "static-1.3429",
  "totals-ui-components": "static-1.22910",
  "ContentData": "static-1.67592",
  "layout-data-lib": "static-1.9270",
  "deal-intel-decorators": "static-1.1118",
  "tanstack-virtual": "static-1.24",
  "draft-content-plugins": "static-1.27629",
  "stripe-connect-js": "static-1.63",
  "commerce-totals-service-types": "static-1.3606",
  "advanced-menus-core": "static-1.14765",
  "advanced-menus-lib": "static-1.11746",
  "ui-memberships-settings-lib": "static-1.33332",
  "deal-intel-utils": "static-1.1122",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14764",
  "simple-menus-lib": "static-1.16281"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11449",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.444",
  "data-fetching-client": "/data-fetching-client/static-1.9441",
  "graphql": "/graphql/static-1.76",
  "head-dlb": "/head-dlb/static-1.4754",
  "hs-test-utils": "/hs-test-utils/static-1.7770",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9391",
  "hubspot-dlb": "/hubspot-dlb/static-2.1796",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
  "HubStyleTokens": "/HubStyleTokens/static-2.11187",
  "I18n": "/I18n/static-7.1559",
  "jasmine-runner": "/jasmine-runner/static-1.6238",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11509",
  "quartz": "/quartz/static-1.6680",
  "react-dlb": "/react-dlb/static-1.71",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7836",
  "foundations-components": "/foundations-components/static-1.7452",
  "foundations-theming": "/foundations-theming/static-1.4173",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.5966",
  "integrations-lib": "/integrations-lib/static-1.15299",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.18853",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "property-management-iframe": "/property-management-iframe/static-1.12172",
  "quartz-config": "/quartz-config/static-1.458",
  "quartz-core": "/quartz-core/static-1.5899",
  "quartz-routing": "/quartz-routing/static-1.110",
  "quick-fetch": "/quick-fetch/static-1.3701",
  "react": "/react/static-7.177",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16405",
  "react-router-dom": "/react-router-dom/static-5.26",
  "rpc-client-utils": "/rpc-client-utils/static-1.4396",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6658",
  "ts-schema": "/ts-schema/static-1.3872",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10895",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9312",
  "ui-universal-auth": "/ui-universal-auth/static-1.8642",
  "UIComponents": "/UIComponents/static-3.8134",
  "usage-tracker": "/usage-tracker/static-1.7098",
  "usage-tracker-core": "/usage-tracker-core/static-1.6948",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.387",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven": "/raven/static-3.5624",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9391",
  "react-redux": "/react-redux/static-7.66",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.84",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3195",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2957",
  "quartz-webpack": "/quartz-webpack/static-1.2904",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "HeadJS": "/HeadJS/static-2.701",
  "framer-motion": "/framer-motion/static-1.66",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2881",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.146",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.77",
  "react-utils": "/react-utils/static-2.5142",
  "StyleGuideUI": "/StyleGuideUI/static-3.483",
  "jasmine": "/jasmine/static-4.4095",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8252",
  "ai-rendering-library": "/ai-rendering-library/static-1.9193",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.54",
  "chirp-fetch": "/chirp-fetch/static-1.1647",
  "connections-embed-lib": "/connections-embed-lib/static-1.571",
  "copilot-toolkit": "/copilot-toolkit/static-1.10432",
  "foundations-assets": "/foundations-assets/static-1.4596",
  "hs-lodash": "/hs-lodash/static-4.45",
  "laboratory-lib": "/laboratory-lib/static-3.6927",
  "marketplace-embed": "/marketplace-embed/static-1.21384",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17386",
  "marketplace-ui-assets-core": "/marketplace-ui-assets-core/static-1.18790",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16260",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.8749",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.18809",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13024",
  "sanitize-text": "/sanitize-text/static-1.7904",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8460",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5512",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4784",
  "wootric-nps": "/wootric-nps/static-1.6745",
  "customer-data-objects": "/customer-data-objects/static-1.7408",
  "property-translator": "/property-translator/static-1.5178",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3721",
  "floating-ui": "/floating-ui/static-1.50",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1889",
  "hs-story-utils": "/hs-story-utils/static-1.9192",
  "react-aria": "/react-aria/static-1.60",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.93",
  "tanstack-table": "/tanstack-table/static-1.49",
  "trellis-assets": "/trellis-assets/static-1.1094",
  "ui-fonts": "/ui-fonts/static-1.449",
  "ui-images": "/ui-images/static-2.1083",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2656",
  "foundations-theming-base": "/foundations-theming-base/static-1.3158",
  "stylex": "/stylex/static-1.26",
  "flux-actions": "/flux-actions/static-1.302",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7691",
  "hs-promise-utils": "/hs-promise-utils/static-1.5355",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4643",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12714",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5348",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7553",
  "quartz-i18n": "/quartz-i18n/static-1.355",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10137",
  "reselect": "/reselect/static-2.16",
  "rxjs": "/rxjs/static-5.10",
  "sanitize": "/sanitize/static-1.4239",
  "superstore": "/superstore/static-1.4536",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9909",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7331",
  "hub-http-janus": "/hub-http-janus/static-1.784",
  "hubspotter-http": "/hubspotter-http/static-1.4446",
  "immer": "/immer/static-1.33",
  "immutable-less": "/immutable-less/static-1.4418",
  "nav-meta": "/nav-meta/static-1.28788",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10000",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17597",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3644",
  "property-management-common": "/property-management-common/static-1.4459",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8805",
  "dispatcher": "/dispatcher/static-1.130",
  "general-store": "/general-store/static-6.20",
  "icons": "/icons/static-2.618",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.474",
  "quartz-auth": "/quartz-auth/static-1.355",
  "quartz-head": "/quartz-head/static-1.345",
  "quartz-test": "/quartz-test/static-1.355",
  "usage-tracker-container": "/usage-tracker-container/static-1.7088",
  "csstype": "/csstype/static-1.50",
  "storybook-react": "/storybook-react/static-1.27",
  "trellis-story-utils": "/trellis-story-utils/static-1.4287",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4935",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "cssUtils": "/cssUtils/static-1.721",
  "HubStyle": "/HubStyle/static-2.11495",
  "bender-build-tools": "/bender-build-tools/static-1.2899",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20167",
  "ContentUtils": "/ContentUtils/static-1.67517",
  "sassPrefix": "/sassPrefix/static-1.151",
  "avatar-components": "/avatar-components/static-1.2250",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38754",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12767",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12906",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13380",
  "ExportDialog": "/ExportDialog/static-6.10152",
  "highlight.js": "/highlight.js/static-1.73",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40545",
  "reporting-data": "/reporting-data/static-1.66362",
  "reporting-snowflake": "/reporting-snowflake/static-1.54980",
  "reporting-ui-components": "/reporting-ui-components/static-2.63634",
  "reporting-visualizations": "/reporting-visualizations/static-1.58438",
  "ui-addon-teams": "/ui-addon-teams/static-1.21192",
  "magpie-lib": "/magpie-lib/static-1.5358",
  "magpie-types": "/magpie-types/static-1.4818",
  "simple-logging-lib": "/simple-logging-lib/static-1.2815",
  "navigation-components": "/navigation-components/static-1.17151",
  "navigation-messaging": "/navigation-messaging/static-1.6478",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10230",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7749",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3713",
  "signup-constants": "/signup-constants/static-1.18318",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7827",
  "ai-studio-lib": "/ai-studio-lib/static-1.10894",
  "ui-tool-access": "/ui-tool-access/static-1.9908",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7918",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5515",
  "usage-tracker-public": "/usage-tracker-public/static-1.6909",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4413",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.102",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2763",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "merchandise-lib": "/merchandise-lib/static-1.257",
  "atom": "/atom/static-1.4835",
  "purchase-motions-components": "/purchase-motions-components/static-1.5433",
  "salesImages": "/salesImages/static-1.520",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4272",
  "batch-promise": "/batch-promise/static-1.1314",
  "crm-component-utils": "/crm-component-utils/static-1.38394",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5636",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6634",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3397",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7854",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9389",
  "cms-field-types": "/cms-field-types/static-1.4571",
  "content-icons-ui": "/content-icons-ui/static-1.2142",
  "underscore": "/underscore/static-1.8",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7014",
  "crm-message-bus": "/crm-message-bus/static-1.42242",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21188",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9589",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4495",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3815",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6539",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.733",
  "onboarding-tours": "/onboarding-tours/static-1.16209",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reference-resolvers": "/reference-resolvers/static-1.7924",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12951",
  "academy-common-lib": "/academy-common-lib/static-1.12840",
  "content-assistance-lib": "/content-assistance-lib/static-1.7396",
  "dashboard-lib": "/dashboard-lib/static-1.80463",
  "file-manager-components": "/file-manager-components/static-1.22779",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17780",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17502",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17494",
  "prosemirror": "/prosemirror/static-1.13",
  "react-colorpicker": "/react-colorpicker/static-2.9976",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "rich-text-lib": "/rich-text-lib/static-1.19414",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8454",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4530",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10662",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8787",
  "user-context": "/user-context/static-1.4859",
  "persist-promise": "/persist-promise/static-1.3471",
  "reporting-client-types": "/reporting-client-types/static-1.2372",
  "growth-payments-core": "/growth-payments-core/static-1.24623",
  "highcharts": "/highcharts/static-8.98",
  "reporting-plugins": "/reporting-plugins/static-1.9936",
  "reporting-reports": "/reporting-reports/static-1.66040",
  "idb-keyval": "/idb-keyval/static-1.38",
  "reactive-lib": "/reactive-lib/static-1.490",
  "apps-service-types": "/apps-service-types/static-1.3643",
  "oauth-service-types": "/oauth-service-types/static-1.4004",
  "codemirror": "/codemirror/static-5.89",
  "feedback-loader": "/feedback-loader/static-1.28787",
  "react-codemirror": "/react-codemirror/static-1.10392",
  "onboarding-scopes": "/onboarding-scopes/static-1.6229",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4423",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7460",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14539",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3419",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8444",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4288",
  "nav-client-types": "/nav-client-types/static-1.2120",
  "purchase-motions-api": "/purchase-motions-api/static-1.5436",
  "trials-service-types": "/trials-service-types/static-1.3689",
  "card-properties-lib": "/card-properties-lib/static-1.43421",
  "crm-actions": "/crm-actions/static-1.6059",
  "crm-cards-data": "/crm-cards-data/static-1.1138",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.42805",
  "customer-data-properties": "/customer-data-properties/static-1.50682",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8718",
  "customer-data-tracking": "/customer-data-tracking/static-1.6646",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3591",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3932",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3486",
  "external-options-client-types": "/external-options-client-types/static-1.3951",
  "react-dnd-compat": "/react-dnd-compat/static-1.4388",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5118",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2835",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1259",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.275",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7290",
  "academy-service-client": "/academy-service-client/static-1.3446",
  "final-form": "/final-form/static-1.64",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27849",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8151",
  "immerable": "/immerable/static-1.3919",
  "video-components-external": "/video-components-external/static-1.10468",
  "video-data-lib": "/video-data-lib/static-1.34126",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8333",
  "payment-link-components": "/payment-link-components/static-1.22835",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9654",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23859",
  "viral-links-lib": "/viral-links-lib/static-1.6792",
  "data-token-picker": "/data-token-picker/static-1.15987",
  "FileManagerLib": "/FileManagerLib/static-1.38419",
  "react-flip-move": "/react-flip-move/static-1.64",
  "timezone-utils": "/timezone-utils/static-2.5009",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16898",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8182",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "edison-service-client-types": "/edison-service-client-types/static-1.154",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2970",
  "crm_data": "/crm_data/static-4.91099",
  "crm-links": "/crm-links/static-1.6018",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45317",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.14868",
  "crm-fe-perf": "/crm-fe-perf/static-1.22671",
  "calling-global-api": "/calling-global-api/static-1.63529",
  "calling-internal-common": "/calling-internal-common/static-1.31056",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64911",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57205",
  "commerce-products-lib": "/commerce-products-lib/static-1.8746",
  "google-libphonenumber": "/google-libphonenumber/static-1.32",
  "hs-entities": "/hs-entities/static-1.435",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4018",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.398",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47849",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3755",
  "property-value-citations": "/property-value-citations/static-1.1296",
  "pulse": "/pulse/static-1.266",
  "smart-property-lib": "/smart-property-lib/static-1.5750",
  "tiered-pricing": "/tiered-pricing/static-1.777",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10759",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6350",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11323",
  "content-media-compositions": "/content-media-compositions/static-2.15330",
  "media-bridge-lib": "/media-bridge-lib/static-1.18509",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5663",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4853",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3441",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-3.69",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.21251",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3608",
  "audio-components": "/audio-components/static-1.5561",
  "FileManagerCore": "/FileManagerCore/static-1.38278",
  "FileManagerImages": "/FileManagerImages/static-1.35930",
  "video-components": "/video-components/static-1.12471",
  "crm_universal": "/crm_universal/static-1.21604",
  "customer-data-email": "/customer-data-email/static-1.17611",
  "calling-error-reporting": "/calling-error-reporting/static-1.31062",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36403",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38758",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18396",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11028",
  "customer-data-content": "/customer-data-content/static-1.26814",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.53888",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20785",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17030",
  "project-storage": "/project-storage/static-1.4497",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71023",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5269",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5096",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9474",
  "fsm": "/fsm/static-1.3496",
  "policy-lib": "/policy-lib/static-1.6549",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10802",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6303",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.136",
  "products-iframe-lib": "/products-iframe-lib/static-1.7219",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9773",
  "directed-graph": "/directed-graph/static-1.701",
  "event-emitter": "/event-emitter/static-1.712",
  "react-tinymce": "/react-tinymce/static-1.54524",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9537",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53650",
  "tinymce-plugins": "/tinymce-plugins/static-1.56764",
  "tinymce-themes": "/tinymce-themes/static-1.55620",
  "hls.js": "/hls.js/static-1.33",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4298",
  "video-embed": "/video-embed/static-1.34960",
  "social-insights-client-types": "/social-insights-client-types/static-1.21254",
  "sequences-lib": "/sequences-lib/static-1.7634",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10111",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17826",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36335",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9705",
  "utility-belt": "/utility-belt/static-1.2306",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.21850",
  "products-ui-components": "/products-ui-components/static-1.39265",
  "quotes-client-types": "/quotes-client-types/static-1.37111",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.79742",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8849",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6671",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.53904",
  "commerce-products-api": "/commerce-products-api/static-1.1905",
  "SafeStorage": "/SafeStorage/static-1.4169",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.55962",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.101699",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34913",
  "sales-views-client-types": "/sales-views-client-types/static-1.4056",
  "hub-http-contrib": "/hub-http-contrib/static-1.2809",
  "interframe": "/interframe/static-3.4556",
  "tinymce-data": "/tinymce-data/static-1.39735",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4978",
  "layout-dnd-components": "/layout-dnd-components/static-1.11970",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10945",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13691",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8864",
  "outpost": "/outpost/static-1.3972",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7491",
  "customer-data-associations": "/customer-data-associations/static-1.7101",
  "framework-data-table": "/framework-data-table/static-2.11334",
  "customer-data-rte": "/customer-data-rte/static-1.32361",
  "cv-backend-services": "/cv-backend-services/static-1.1484",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5311",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14131",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4877",
  "qrcode-generator": "/qrcode-generator/static-1.63",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7076",
  "commerce-permissions": "/commerce-permissions/static-1.517",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.270",
  "property-description-translator": "/property-description-translator/static-1.3624",
  "FireAlarmUi": "/FireAlarmUi/static-1.4295",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3961",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3429",
  "totals-ui-components": "/totals-ui-components/static-1.22910",
  "ContentData": "/ContentData/static-1.67592",
  "layout-data-lib": "/layout-data-lib/static-1.9270",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1118",
  "tanstack-virtual": "/tanstack-virtual/static-1.24",
  "draft-content-plugins": "/draft-content-plugins/static-1.27629",
  "stripe-connect-js": "/stripe-connect-js/static-1.63",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3606",
  "advanced-menus-core": "/advanced-menus-core/static-1.14765",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11746",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33332",
  "deal-intel-utils": "/deal-intel-utils/static-1.1122",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14764",
  "simple-menus-lib": "/simple-menus-lib/static-1.16281"
}
};
